import { TalentAgencyAssociatedAccounts } from '@anytag/shared-organisms';
import { useTalentAgencyDetailsContext } from './TalentAgencyDetailsContext';

export const TalentAgencyBusiness = () => {
  const { talentAgency } = useTalentAgencyDetailsContext();

  return <TalentAgencyAssociatedAccounts talentAgencyId={talentAgency.id} />;
};
